/*
  Copyright (c) 2025 Fluxonix Inc. All rights reserved.
*/
import { api } from "../api"
export async function getWorkItem(workItemId) {
  if (!workItemId) {
    throw new Error("A work item ID is required.");
  }

  const response = await api.get(`/api/secure/work-items/${workItemId}`);
  return response.data;
}